export default __webpack_public_path__ + "static/24-7b579bbe14288d3e49bdc5f4e5133996.jpg";